import React from 'react';
import { Zap, ArrowRight } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="bg-slate-950 border-t border-slate-800 pt-20 pb-10 relative overflow-hidden" data-id="element-21">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-emerald-900/20 blur-[100px] rounded-full pointer-events-none" data-id="element-22"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-23">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16" data-id="element-24">
          <div data-id="element-25">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-26">
              Join the Future of Clean Energy
            </h2>
            <p className="text-slate-400 text-lg max-w-md" data-id="element-27">
              Turning waste into power, and problems into progress. Partner with
              us to build a sustainable tomorrow.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 md:justify-end" data-id="element-28">
            <a href="#investors" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold text-white bg-emerald-600 rounded-full hover:bg-emerald-500 transition-all hover:shadow-[0_0_30px_rgba(16,185,129,0.3)]" data-id="element-29">
              Invest in Green Fuel
            </a>
            <a href="mailto:partner@greenfuel.com" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold text-white bg-slate-800 border border-slate-700 rounded-full hover:bg-slate-700 hover:border-slate-600 transition-all" data-id="element-30">
              Partner With Us
              <ArrowRight className="ml-2 w-5 h-5" data-id="element-31" />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 py-12 border-t border-slate-800/50" data-id="element-32">
          <div className="col-span-1 md:col-span-2" data-id="element-33">
            <div className="flex items-center gap-2 mb-4" data-id="element-34">
              <Zap className="w-6 h-6 text-emerald-400" data-id="element-35" />
              <span className="text-xl font-bold text-white" data-id="element-36">Green Fuel</span>
            </div>
            <p className="text-slate-500 max-w-sm" data-id="element-37">
              AI-optimized bio-digesters converting methane waste into clean
              electricity and hydrogen.
            </p>
          </div>
          <div data-id="element-38">
            <h3 className="text-white font-semibold mb-4" data-id="element-39">Company</h3>
            <ul className="space-y-3" data-id="element-40">
              <li data-id="element-41">
                <a href="#solution" className="text-slate-400 hover:text-emerald-400 transition-colors" data-id="element-42">
                  Solution
                </a>
              </li>
              <li data-id="element-43">
                <a href="#market" className="text-slate-400 hover:text-emerald-400 transition-colors" data-id="element-44">
                  Market
                </a>
              </li>
              <li data-id="element-45">
                <a href="#investors" className="text-slate-400 hover:text-emerald-400 transition-colors" data-id="element-46">
                  Investors
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-47">
            <h3 className="text-white font-semibold mb-4" data-id="element-48">Legal</h3>
            <ul className="space-y-3" data-id="element-49">
              <li data-id="element-50">
                <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors" data-id="element-51">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-52">
                <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors" data-id="element-53">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800/50 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-54">
          <p className="text-slate-500 text-sm" data-id="element-55">
            © {new Date().getFullYear()} Green Fuel Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-56">
            <a href="#" className="text-slate-500 hover:text-white transition-colors" data-id="element-57">
              Twitter
            </a>
            <a href="#" className="text-slate-500 hover:text-white transition-colors" data-id="element-58">
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </footer>;
}